module.exports = __webpack_public_path__ + "734b469932d4b2f50a10a5bf18a830b2.glb";